<div [class.open]="open && vars" class="mobile_popup">
    <ng-container *ngIf="vars">
        <a (click)="setAnswer(item.key)" *ngFor="let item of vars">
            <i class="icon-{{item.icon ? item.icon : 'minus'}}"></i>
            <span>{{ item.title }}</span>
        </a>
    </ng-container>
</div>
<div (click)="setAnswer(false);" [class.open]="open" class="overflow"></div>
